"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.truthyOrArrayPredicate = exports.truthyAndArrayPredicate = exports.isBrowser = exports.noop = void 0;
var noop = function () { };
exports.noop = noop;
exports.isBrowser = typeof window !== 'undefined' &&
    typeof navigator !== 'undefined' &&
    typeof document !== 'undefined';
function truthyAndArrayPredicate(conditions) {
    return conditions.every(function (i) { return Boolean(i); });
}
exports.truthyAndArrayPredicate = truthyAndArrayPredicate;
function truthyOrArrayPredicate(conditions) {
    return conditions.some(function (i) { return Boolean(i); });
}
exports.truthyOrArrayPredicate = truthyOrArrayPredicate;
